import {mapValues} from 'lodash'
import {isMoment} from 'moment-timezone'
import hash from 'stable-hash'

//`swr` natively uses `stable-hash` to do comparison which is broken for `Moment`
const swrCompare = (a: unknown, b: unknown) =>
  hash(fixMomentRecursive(a)) === hash(fixMomentRecursive(b))

export const swrOptions = {
  compare: swrCompare
}

// `hash` does not work for `Moment` as they never hash to the same value
// This converts all `Moments` `toISOString` so that we have something stable to hash on.
function fixMomentRecursive(o: unknown): unknown {
  if (isMoment(o)) {
    return o.toISOString()
  }
  if (typeof o === 'object') {
    return mapValues(o, value => fixMomentRecursive(value))
  }
  return o
}
